import { Component, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Pagination } from '@app/shared/model';
import { BolsaService } from '@app/features-modules/gestao-bolseiros/components/api/services';
import { EnumService } from '@app/features-modules/bolsa-de-profissionais/api';
import { ApiService } from '@core/providers/http';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { CommonModule } from '@angular/common';
import { Toast } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { TableComponent } from '@app/shared/components/table/table.component';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { TableColumn } from '../../../../shared/components/table/table.component';
import { VagaReportService } from '@app/features-modules/bolsa-de-profissionais/services/vaga-report.service';
import {
  ProfissaoCatalogoService,
  EmpresaSectorService,
  EspecialidadeFuncaoService,
  ExperienciaProfissionalService,
  ProfissionaisEnumService,
} from '@app/features-modules/bolsa-de-profissionais/services';
import { forkJoin } from 'rxjs';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-report-vagas',
  providers: [
    MessageService,
    ApiService,
    BolsaService,
    EnumService,
    VagaReportService,
    EmpresaSectorService,
    EspecialidadeFuncaoService,
    ProfissaoCatalogoService,
    ExperienciaProfissionalService,
  ],
  imports: [
    CommonModule,
    DataVoidComponent,
    Toast,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    Dialog,
    SelectModule,
    TableComponent,
    TableModule,
    DatePickerModule,
  ],
  templateUrl: './report-vagas.component.html',
  styleUrls: ['./report-vagas.component.scss'],
})
export class ReportVagasComponent implements OnInit {
  formVagas!: FormGroup;
  vagas: any[] = [];
  pagination: Pagination<any> = new Pagination<any>({
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    data: [],
  });
  totalVagas: number = 0;
  showModalVagas = false;
  carregando = false;
  appliedFiltersVagas: { label: string; value: string }[] = [];
  empreseSectorService = inject(EmpresaSectorService);
  enumService = inject(ProfissionaisEnumService);
  profissaoCatalogo = inject(ProfissaoCatalogoService);
  especialidadeFuncao = inject(EspecialidadeFuncaoService);
  experienciaProfissional = inject(ExperienciaProfissionalService);
  private auth = inject(AuthStore);

  // Dropdown options
  subSectorList = [
    { label: 'Recursos Minerais', value: 1 },
    { label: 'Petróleo e Gás', value: 2 },
  ];
  groupPersonList = [
    { label: 'Responsável', value: 1 },
    { label: 'Técnico', value: 2 },
    { label: 'Operário', value: 3 },
    { label: 'Administração e Serviços', value: 4 },
  ];
  especialidadeList: any[] = [];
  regimeList: any[] = [];
  habilitacaoList: any[] = [];
  experienciaList: any[] = [];
  generoOptions: any[] = [];
  empresaSectorList: any[] = [];
  estadoProfissionalList: any[] = [];
  profissaoList: any[] = [];
  idadeOptions = Array.from({ length: 15 }, (_, i) => {
    const idade = 18 + i;
    return { label: idade.toString(), value: idade };
  });
  instituicaoGestoraList: any[] = [];

  columnsVagas: TableColumn[] = [
    { field: 'empresa', header: 'Empresa', type: 'text' },
    { field: 'especialidade', header: 'Especialidade', type: 'text' },
    { field: 'profissao', header: 'Profissão de Referência', type: 'text' },
    {
      field: 'numVaga',
      header: 'Nº de vagas previstas',
      type: 'badge',
      severityField: 'numVaga',
      badgeSeverityFunction: (rowData: any) =>
        rowData.numVaga > 0 ? 'info' : 'danger',
    },
    {
      field: 'numVagaAberta',
      header: 'Nº de vagas Abertas',
      type: 'badge',
      severityField: 'numVagaAberta',
      badgeSeverityFunction: (rowData: any) =>
        rowData.numVagaAberta > 0 ? 'info' : 'danger',
    },
    {
      field: 'nCandidaturas',
      header: 'Nº de Candidaturas',
      type: 'badge',
      severityField: 'nCandidaturas',
      badgeSeverityFunction: (rowData: any) =>
        rowData.nCandidaturas > 0 ? 'success' : 'danger',
    },
    {
      field: 'nContratados',
      header: 'Nº de Contratados',
      type: 'badge',
      severityField: 'nContratados',
      badgeSeverityFunction: (rowData: any) =>
        rowData.nContratados > 0 ? 'info' : 'danger',
    },
    {
      field: 'experienciaProfissionalDescricao',
      header: 'Experiência Profissional',
      type: 'text',
    },
    { field: 'regimeDescricao', header: 'Regime de Trabalho', type: 'text' },
  ];

  titlleOptionsVagas = [
    {
      label: 'Relatório de Vagas de Emprego',
      value: 'Relatório de Vagas de Emprego',
    },
    {
      label: 'Relatório de Vagas de Emprego Activas',
      value: 'Relatório de Vagas de Emprego Activas',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private vagasServiceReport: VagaReportService,
  ) {}

  ngOnInit() {
    if (this.auth.hasAny(['Relatorio_de_Vagas'])) {
      this.showModalVagas = false;
      this.formVagas = this.fb.group({
        subsector: [null],
        profissao: [null],
        especialidade: [null],
        grupWork: [null],
        regime: [null],
        habilitacaoAcademica: [null],
        ProfissionalExperiencia: [null],
        empresaSector: [null],
        titulo: ['Relatório de Vagas de Emprego', Validators.required],
      });

      this.formVagas.controls['subsector'].valueChanges.subscribe((value) => {
        // Sempre limpa o array ao mudar - inclusive ao iniciar
        this.profissaoList = [];

        // Se o valor for nulo, undefined ou vazio, reseta o campo ProfissaoReferencia e retorna
        if ([null, undefined, ''].includes(value)) {
          this.formVagas.get('ProfissionalExperiencia')?.setValue(null);
          return;
        }

        // Busca as profissões normalmente
        this.getAllProfissoes({
          SubSector: value,
          pageSize: 500,
        });
      });

      // TODO: carregar listas dinâmicas se necessário
      this.loadDropdowns();
      this.getAllProfissoes();
      this.getAllEspecialidade();
      this.getAllEmpresaSector();
      this.loadDataVagas();
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  getAllProfissoes(params: any = {}) {
    this.profissaoCatalogo
      .list({ ...params, pageSize: 500 })
      .subscribe((profissoes) => {
        this.profissaoList = profissoes.data.map((item: any) => ({
          label: item.descricao,
          value: item.id,
        }));
      });
  }

  getAllEspecialidade() {
    this.especialidadeFuncao
      .list({ pageSize: 100 })
      .subscribe((especialidade) => {
        this.especialidadeList = especialidade.data.map((item: any) => ({
          label: item.designacao,
          value: item.id,
        }));
      });
  }

  getAllEmpresaSector() {
    this.empreseSectorService
      .list({ pageSize: 100 })
      .subscribe((empresaSector) => {
        this.empresaSectorList = empresaSector.data.map((item: any) => ({
          label: item.nome,
          value: item.id,
        }));
      });
  }

  loadDropdowns() {
    forkJoin({
      nivelAcademico: this.enumService.getAllNivelHabilitacao(),
      regime: this.enumService.getAllRegimeTrabalho(),
      anoExperiencia: this.enumService.getAllAnoExperiencia(),
    }).subscribe((response) => {
      // Enums
      if (response.nivelAcademico?.data) {
        this.habilitacaoList = Object.entries(response.nivelAcademico.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
      }
      if (response.regime?.data) {
        this.regimeList = Object.entries(response.regime.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
      }
      if (response.anoExperiencia?.data) {
        this.experienciaList = Object.entries(response.anoExperiencia.data).map(
          ([key, value]) => ({
            label: value,
            value: key,
          }),
        );
      }
    });
  }

  updateappliedFiltersVagas() {
    const formValue = this.formVagas.value;
    const filters: { label: string; value: string }[] = [];

    if (formValue.subsector) {
      const subsector = this.subSectorList.find(
        (s) => s.value === formValue.subsector,
      )?.label;
      filters.push({
        label: 'Subsector',
        value: subsector || formValue.subsector,
      });
    }

    if (formValue.profissao) {
      filters.push({
        label: 'Profissão de Referência',
        value: formValue.profissao,
      });
    }

    if (formValue.especialidade) {
      filters.push({
        label: 'Especialidade',
        value: formValue.especialidade,
      });
    }

    if (formValue.grupWork) {
      const grupo = this.groupPersonList.find(
        (g) => g.value === formValue.grupWork,
      )?.label;
      filters.push({
        label: 'Grupo de Trabalho',
        value: grupo || formValue.grupWork,
      });
    }

    if (formValue.regime) {
      const regime = this.regimeList.find(
        (r) => r.id === formValue.regime,
      )?.label;
      filters.push({
        label: 'Regime de Trabalho',
        value: regime || formValue.regime,
      });
    }

    if (formValue.habilitacaoAcademica) {
      const habil = this.habilitacaoList.find(
        (h) => h.label === formValue.habilitacaoAcademica,
      )?.label;
      filters.push({
        label: 'Habilitação Acadêmica',
        value: habil || formValue.habilitacaoAcademica,
      });
    }

    if (formValue.ProfissionalExperiencia) {
      const experiencia = this.experienciaList.find(
        (e) => e.label === formValue.ProfissionalExperiencia,
      )?.label;
      filters.push({
        label: 'Experiência Profissional',
        value: experiencia || formValue.ProfissionalExperiencia,
      });
    }

    if (formValue.empresaSector) {
      const empresa = this.empresaSectorList.find(
        (e) => e.value === formValue.empresaSector,
      )?.label;
      filters.push({
        label: 'Empresa do Sector',
        value: empresa || formValue.empresaSector,
      });
    }

    this.appliedFiltersVagas = filters;
  }

  onSubmitVagas() {
    this.formVagas.markAllAsTouched();
    if (this.formVagas.valid) {
      this.pagination.pageNumber = 1;
      this.loadDataVagas();
      this.updateappliedFiltersVagas();
      this.showModalVagas = false;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha os campos obrigatórios do formulário.',
        life: 3000,
      });
    }
  }

  limparFiltrosVagas() {
    this.formVagas.reset({
      titulo: 'Relatório de Vagas de Emprego',
      subsector: null,
      profissao: null,
      especialidade: null,
      grupWork: null,
      regime: null,
      habilitacaoAcademica: null,
      ProfissionalExperiencia: null,
      empresaSector: null,
    });
    this.appliedFiltersVagas = [];
    this.pagination.pageNumber = 1;
    this.loadDataVagas();
    this.showModalVagas = false;
    this.messageService.add({
      severity: 'info',
      summary: 'Filtros Reiniciados',
      detail: 'Parâmetros de pesquisa restaurados para o padrão.',
      life: 2500,
    });
  }

  emitirPdfComFiltros() {
    this.formVagas.markAllAsTouched();
    if (this.formVagas.valid) {
      this.downloadPdf();
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha os campos obrigatórios para exportar o PDF.',
        life: 3000,
      });
    }
  }

  emitirExcelComFiltros() {
    this.formVagas.markAllAsTouched();
    if (this.formVagas.valid) {
      this.downloadExcel();
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha os campos obrigatórios para exportar o Excel.',
        life: 3000,
      });
    }
  }

  loadDataVagas(queryParams?: any) {
    this.carregando = true;
    const reportParams = this.buildReportParams();
    const params = {
      ...reportParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };
    console.log('Parametros enviados para filtrar vagas:', params);
    this.vagasServiceReport.filtrarVagas(params).subscribe({
      next: (res) => {
        this.carregando = false;
        console.log('dados do back', res);
        this.pagination = new Pagination<any>().deserialize(res);
        const total = res.totalRecords ?? this.pagination.data?.length ?? 0;
        this.pagination.totalRecords = total;
        this.pagination.pageSize = res.pageSize ?? this.pagination.pageSize ?? 10;
        this.pagination.pageNumber = res.pageNumber ?? this.pagination.pageNumber ?? 1;
        this.pagination.totalPages =
          res.totalPages ?? Math.ceil(total / (this.pagination.pageSize || 10));
        this.vagas = res.data || [];
        this.totalVagas = total;

        if (total > 0) {
          this.messageService.add({
            severity: 'success',
            summary: 'Relatório Emitido',
            detail: `${total} vaga(s) encontrada(s).`,
            life: 3000,
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Pesquisa Concluída',
            detail: 'Nenhuma vaga encontrada com os filtros informados.',
            life: 3500,
          });
        }
      },
      error: (err) => {
        this.carregando = false;
        this.totalVagas = 0;
        this.vagas = [];
        console.error('Erro ao carregar dados de vagas:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro na Consulta',
          detail: 'Não foi possível carregar os dados das vagas. Verifique os filtros ou tente novamente.',
          life: 4000,
        });
      },
    });
  }

  /**
   * Constrói os parâmetros para exportação de relatórios a partir do formulário de filtros.
   * Apenas campos com valores definidos são incluídos. Ajusta nomes de propriedades
   * quando necessário para compatibilidade com a API.
   */
  private buildReportParams(): any {
    const form = this.formVagas.value;
    const params: any = {};

    if (
      form.subsector !== null &&
      form.subsector !== undefined &&
      form.subsector !== ''
    ) {
      params.subsector = form.subsector;
    }
    if (
      form.profissao !== null &&
      form.profissao !== undefined &&
      form.profissao !== ''
    ) {
      params.profissao = form.profissao;
      params.ProfissaoReferencia = form.profissao;
    }
    if (
      form.especialidade !== null &&
      form.especialidade !== undefined &&
      form.especialidade !== ''
    ) {
      params.especialidade = form.especialidade;
    }
    if (
      form.grupWork !== null &&
      form.grupWork !== undefined &&
      form.grupWork !== ''
    ) {
      params.grupWork = form.grupWork;
    }
    if (
      form.regime !== null &&
      form.regime !== undefined &&
      form.regime !== ''
    ) {
      params.regime = form.regime;
    }
    if (
      form.habilitacaoAcademica !== null &&
      form.habilitacaoAcademica !== undefined &&
      form.habilitacaoAcademica !== ''
    ) {
      params.habilitacaoAcademica = form.habilitacaoAcademica;
    }
    if (
      form.ProfissionalExperiencia !== null &&
      form.ProfissionalExperiencia !== undefined &&
      form.ProfissionalExperiencia !== ''
    ) {
      // renomeia o campo para melhor legibilidade na API
      params.profissionalExperiencia = form.ProfissionalExperiencia;
      params.experienciaProfissional = form.ProfissionalExperiencia;
      params.ProfissionalExperiencia = form.ProfissionalExperiencia;
    }
    if (
      form.empresaSector !== null &&
      form.empresaSector !== undefined &&
      form.empresaSector !== ''
    ) {
      params.empresaSector = form.empresaSector;
    }
    return params;
  }

  /**
   * Exporta o relatório em PDF utilizando apenas os filtros preenchidos.
   */
  downloadPdf() {
    const params = this.buildReportParams();
    console.log('Exportando PDF com filtros:', params);
    this.vagasServiceReport.sendReportPDF(params).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Relatorio-Vagas.pdf';
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao exportar relatório.',
          life: 3000,
        });
      },
    );
  }

  /**
   * Exporta o relatório em Excel utilizando apenas os filtros preenchidos.
   */
  downloadExcel() {
    const params = this.buildReportParams();
    console.log('Exportando Excel com filtros:', params);
    this.vagasServiceReport.sendReportExcel(params).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Relatorio-Vagas.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao exportar relatório.',
          life: 3000,
        });
      },
    );
  }

  onPageChange(event: any) {
    const page =
      event.page !== undefined
        ? event.page + 1
        : Math.floor((event.first ?? 0) / (event.rows ?? this.pagination.pageSize ?? 10)) + 1;
    this.pagination.pageNumber = page;
    this.pagination.pageSize = event.rows ?? this.pagination.pageSize ?? 10;
    this.loadDataVagas();
  }
}
